import { render, staticRenderFns } from "./NotificationSettingsModal.vue?vue&type=template&id=8fcdcf18&"
import script from "./NotificationSettingsModal.vue?vue&type=script&lang=js&"
export * from "./NotificationSettingsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports